/**
 * 관리자 전환 알약 ($j.F.Mobile.SiteSwitch)
 *
 * CS 는 자기 폰의 같은 앱으로 회원화면(/m)과 모바일관리자(/ma)를 오간다. 그런데 /m 쪽 출구가
 * **서랍(햄버거) → 스크롤 → 내부도구 → 관리자** 네 동작이라, 하루에 수십 번 넘나드는 사람에게는
 * 그 자체가 업무였다. 반대편(/ma → /m)도 하단탭 '전체' → 서랍 → '모바일 가기' 로 같은 값이다.
 * (그 서랍 항목은 이 알약이 자리를 잡은 뒤 없앴다 — 같은 곳으로 가는 길이 둘이면 갈린다)
 *
 * 그래서 이미 검증된 자리를 그대로 쓴다 — 대리진입 복귀 알약($j.F.Mobile.ProxyBar)이 앉는
 * **화면 가장자리 세로중앙**이다. 한 번 누르면 넘어간다. 반대편 알약은
 * Sites/MobileAdmin/Bootstrap 이 /ma 에 붙인다.
 *
 * 노출 판정 `canEnter()` 는 **CS 인가(G5.isMobileAdmin) + 대리 중이 아닌가(G5.maProxyBack)** 둘이다.
 * 불러톡 아이콘(→ /ma/chat)도 같은 함수를 부른다 — 둘이 어긋나면
 * '어떤 화면에서는 보이고 어떤 화면에서는 안 보이는' 상태가 된다.
 *
 * ⚠ 대리 판정을 빼면 안 된다. **대리진입 대상이 관리자 계정일 수도 있다** — CS 가 다른 CS 의
 *   계정으로 들어가면 세션 회원이 곧 관리자라 isMobileAdmin 이 **true 로 선다.** 그러면 복귀
 *   알약과 이 알약이 같은 자리(세로중앙 기본슬롯)에 겹쳐 뜨고, 대리 중인 CS 가 복귀 대신
 *   이걸 눌러 **남의 세션을 쥔 채** /ma 로 넘어간다. 대리 중 출구는 복귀 알약 하나뿐이다.
 *   (경로 축 판정 = ma_proxy_back(). .ai/proxy-login.md §4-4)
 *
 * 그래서 두 알약은 동시에 뜨지 않고, 슬롯을 나눌 필요 없이 둘 다 기본자리를 쓴다.
 * EdgeTab 저장키는 따로 둔다('siteSwitch') — 두 알약은 성격이 달라 옮겨둔 자리가 서로 다르다.
 *
 * 붙은 쪽 가장자리 끝까지 밀면 사라진다(EdgeTab dismiss) — CS 가 화면을 캡쳐할 때 걸리적거려서다.
 * 새로고침하면 그 자리에 다시 뜬다. 복귀 알약(ProxyBar)은 대리 중 유일한 출구라 이 옵션을 켜지 않는다.
 */
const TAB_ID = 'sws-admin';

export default class SiteSwitch {
    /**
     * 지금 이 화면에서 모바일관리자(/ma)로 넘어갈 수 있는가.
     * 알약·서랍항목·불러톡 분기가 공유하는 **단일 판정**이다.
     */
    canEnter = () => {
        if (typeof G5 === 'undefined' || !G5) return false;
        if (parseInt(G5.maProxyBack, 10) > 0) return false;   // 대리 중 — 출구는 복귀 알약뿐
        return !!G5.isMobileAdmin;
    };

    /** CS 면 '관리자' 알약을 띄운다. 아니면 아무것도 하지 않는다. */
    start = () => {
        if (!this.canEnter()) return;
        if (document.getElementById(TAB_ID)) return;   // 같은 페이지 재호출 방어

        const $tab = $(`<button type="button" id="${TAB_ID}" class="jb-edge-tab jb-edge-tab--admin"
                aria-label="모바일관리자로 이동 (끌어서 옮기거나, 가장자리 끝까지 밀어 숨길 수 있음)">
                <i class="fas fa-user-shield" aria-hidden="true"></i><em>관리자</em>
            </button>`);
        $('body').append($tab);

        $j.Ui.EdgeTab.attach($tab[0], { key: 'siteSwitch', dismiss: true, onTap: this._go });
    };

    /**
     * 대리진입과 같은 이유로 replace 다 — 히스토리를 남기면 안드로이드 백버튼이
     * 사이트 경계를 넘나들며 되감긴다 (/ma 에서 뒤로 → 회원화면 → 뒤로 → /ma …).
     */
    _go = () => {
        location.replace('/ma');
    };
}
